import React from 'react';

interface CustomColoredCheckboxProps {
  checked: boolean;
  onChange: () => void;
  color: string;
  label: string;
  count: number;
  id: string;
}

const CustomColoredCheckbox: React.FC<CustomColoredCheckboxProps> = ({
  checked,
  onChange,
  color,
  label,
  id
}) => {
  return (
    <label 
      htmlFor={id}
      className="flex items-center space-x-3 cursor-pointer p-2 rounded-lg transition-colors hover:bg-gray-50"
    >
      <div className="relative">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          className="sr-only"
        />
        <div 
          className={`w-5 h-5 rounded-sm border-2 transition-all duration-200 ${
            checked 
              ? 'border-transparent' 
              : `border-[${color}]`
          }`}
          style={{ 
            backgroundColor: checked ? color : 'transparent',
            borderColor: checked ? color : `border-[${color}]`
          }}
        >
          {checked && (
            <svg 
              className="w-4 h-4 text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" 
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path 
                fillRule="evenodd" 
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
                clipRule="evenodd" 
              />
            </svg>
          )}
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <span className="text-sm font-medium text-gray-700" data-testid={`${label.toLowerCase().replace(/ /g, '-')}`}
        >{label}</span>
      </div>
    </label>
  );
};

export default CustomColoredCheckbox;
